import apiPath from '../../../config/api';

const StockSalesPath = {
    title: "Toko Teknik - Persediaan dan Penjualan",
    basePath: "/technique/stok-sales",
    base: apiPath.retailStockSales,
    stockSalesSum: apiPath.retailStockSalesSum,
    stockSalesExcel: apiPath.retailStockSalesExcel,
    stockSalesFind: apiPath.retailStockSalesFind
}

export default StockSalesPath;
